export default "__VITE_ASSET__CkVnhwPE__"